// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js!./swiper.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("24ad41d3", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/dist/css/swiper.css
// module id = 40
// module chunks = 0